import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { memo } from 'react'
import { getThemeSpacing } from '../styles/appTheme'
import { palette } from '../styles/colors'

interface INameProps {
    text?: string
    // align?: 'inherit' | 'right' | 'left' | 'center' | 'justify'
    color?: string
    // fontWeight?: any
    // size?: number | string
    overrides?: any
    className?: any // allow for styled wrapping
    onClick?(e?: any): any
}

const nameStyles = css({
    margin: 0,
    fontWeight: 'bold',
    color: palette.primaryText,
})

const Name = (props: INameProps) => {
    const { color, overrides, text = 'Untitled', className, onClick } = props
    const colorStyle = color ? { color } : null
    return (
        <h6
            className={className}
            onClick={onClick}
            css={[nameStyles, overrides]}
            style={colorStyle}
            data-testid="ModelName"
        >
            {text}
        </h6>
    )
}

export const StyledName = styled(Name)({
    paddingLeft: getThemeSpacing(1),
    fontSize: '0.8125rem',
})

export default memo(Name)
